var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets / Logo Icons / NFL / Packers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Logo-Icons-/-NFL-/-Packers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GB",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 70 0 70 70 0 70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.81646,14.31612 C17.8416,14.31766 3.5,23.828 3.5,35.08526 C3.5,46.80368 16.96394,55.64006 34.81646,55.64006 C45.23582,55.64006 55.11436,51.9792 61.2423,45.84818 C64.61546,42.4739 66.47046,38.65036 66.4668253,35.08526 C66.46234,29.53468 63.19614,24.32164 57.27008,20.40444 C51.32848,16.47772 43.3552,14.31612 34.81646,14.31612",
    id: "Path",
    fill: "#FFB612",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9164,48.84964 C7.47012,45.21832 4.46992,40.32854 4.46992,35.08526 C4.46992,24.53892 18.65094,15.28702 34.8166,15.28562 C51.7251,15.28492 65.48752,24.16694 65.4978837,35.08526 C65.50082,38.39318 63.74606,41.97144 60.55644,45.16302 C54.60686,51.11582 44.9848,54.67056 34.81674,54.67056 C26.32154,54.67056 18.54342,52.60262 12.91668,48.84964",
    id: "Path",
    fill: "#203731",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.40192,29.64598 C45.96396,26.01606 40.62604,23.49872 34.34032,23.49872 C25.71324,23.49872 18.71786,28.24248 18.71786,34.09364 C18.71786,39.94396 23.65566,45.08126 34.34032,45.07538 C40.75652,45.07244 45.91538,42.30226 48.3252,38.66366 L30.10042,38.6953 L30.04442,33.9626 L61.68008,33.95154 C61.72278,34.33094 61.76702,34.70082 61.76702,35.0854 C61.76702,44.19506 49.70042,51.57936 34.81646,51.57936 C19.9332,51.57936 7.8673,44.19506 7.8673,35.0854 C7.8673,25.97574 20.64944,18.31228 34.81646,18.2566715 C46.6081,18.21204 56.63182,23.0825 60.28722,29.6387 L48.40192,29.64612",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackers);
export default __webpack_public_path__ + "static/media/Packers.67f80d961a1c0a7400535e100b129a27.svg";
export { ForwardRef as ReactComponent };